import { useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import HistoryIcon from "@mui/icons-material/History";
import ConversationHistoryModal from "./ConversationHistoryModal";

interface ConversationHistoryButtonProps {
  color?: "inherit" | "default" | "primary" | "secondary";
}

/** Header button opening the conversation-history modal (Story 16 AC 4). */
export default function ConversationHistoryButton({
  color = "inherit",
}: ConversationHistoryButtonProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Tooltip title="Conversation history">
        <IconButton
          data-testid="hdr-btn-conversation-history"
          data-attr="conversation-history:btn:open-history"
          onClick={() => setOpen(true)}
          color={color}
          size="small"
          aria-label="Open conversation history"
        >
          <HistoryIcon />
        </IconButton>
      </Tooltip>
      {/* Mounted only while open: the modal's debounced search term lives in
          its own state, so keeping it mounted carried the previous query
          across a close and re-ran it behind an empty box. */}
      {open && <ConversationHistoryModal open onClose={() => setOpen(false)} />}
    </>
  );
}
